module.exports = __webpack_public_path__ + "img/zhyk.5a968da3.png";